var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 459,
    height: 400,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.99 24.6l71.318 4.129-8.032 57.069-71.445-4.934L328.99 24.6z",
    fill: "#B3E0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.968 28.593l-41.487 25.365-25.624-29.25-1.867-.108-.262 1.724 20.347 23.225-27.933 29.272-.311 2.043 1.744.25 28.259-29.556 5.125 5.85 10.762-6.578 23.764 34.712 1.791.256.276-1.957-23.555-34.404 31.07-18.995.241-1.713-2.34-.136z",
    fill: "#3A3B39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M239 106.468l6.5-17.968L459 105.234l-2.5 19.266L239 106.468zM228 136.968l6.543-20 218.957 20-2 19.032L228 136.968z",
    fill: "#323234"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.516 285.921L80.4 375.419c3.995-.198 7.581-.12 10.02.265 3.024.476 6.642 2.011 7.486 4.495.674.202 1.432.419 2.244.653h.001c5.268 1.513 12.793 3.674 14.118 6.317 1.438 2.867.146 6.992-2.887 8.037-3.099 1.066-6.788-1.994-6.311-5.235.318-2.171 2.403-3.719 4.544-3.935l-11.994-2.943c-1.147 2.046-4.177 2.902-6.746 3.305-5.841.915-11.739 1.661-17.645 1.939l-1.052 3.626c1.315-1.216 2.79-1.268 4.005-.654 1.798.91 3.024 3.28 2.31 5.485-1.953 6.038-9.175 2.591-9.894-2.101-.072-.471.388-3.877.97-6.246a87.832 87.832 0 01-7.78-.238l-.253-.019c-2.194-.166-4.54-.344-6.269-1.633-1.274-.95-1.908-1.852-2.015-2.701l-8.882 2.18c2.141.216 4.226 1.764 4.544 3.935.477 3.241-3.212 6.301-6.31 5.235-3.034-1.045-4.326-5.17-2.887-8.037 1.325-2.643 8.85-4.804 14.117-6.317l.002-.001h.002c1.058-.304 2.024-.582 2.831-.832.703-.343 1.496-.67 2.363-.979l.043-.082a.192.192 0 01-.04.081c3.993-1.424 9.552-2.477 15.05-3.089l3.143-90.228 6.288.219z",
    fill: "#3A3B39"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.746 263.423v44.776l-82.535 25.643V191.228l88.94-6.734 90.094 13.631v83.055l-96.499-17.757z",
    fill: "#7DB1A1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.127 366.957l79.325-27.202V209.53l-79.325 27.543v129.884z",
    fill: "#B3E0D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.127 237.075l79.325-27.543v-14.469l-79.325 28.229v13.783z",
    fill: "#7DB1A1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.531 226.855l82.471-29.907v-6.609l-208.408-31.847-7.434 46.008 133.371 22.355z",
    fill: "#B3E0D0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.968 202.307a8.228 8.228 0 01-6.75 1.233l-73.738-18.771 40.124-20.109 76.225 12.538-35.861 25.109z",
    fill: "#FFFFFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.578 121.707c1.041-3.04-.966-6.27-4.152-6.684l-66.224-4.731a5.08 5.08 0 00-5.485 3.465l-16.113 50.904c24.437 6.449 47.597 12.267 76.225 12.538l15.749-55.492z",
    fill: "#B3E0D0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.932 115.024l65.681 5.221-13.552 53.032-67.034-12.433 14.905-45.82z",
    fill: "#3A3B39"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.997 292.88c-40.548-3.376-41.812-30.32-41.812-30.32l90.426 12.111s-9.731 21.446-48.614 18.209z",
    fill: "#523B5D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.908 162.445l1.258 7.858-30.406 3.466 2.411-13.526 26.737 2.202z",
    fill: "#3A3B39"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.781 164.655l2.517 5.647h-13.526l2.831 3.465h-3.775l-5.662-3.465-1.258-7.859 18.873 2.212z",
    fill: "#F9B6A8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.857 381.301l24.116-4.194s-5.327-4.739-13.211-4.802l3.774-10.506h-8.178l-6.501 19.502zM146.16 387.066l27.471-3.145s-6.081-5.483-14.679-5.243l4.404-7.13-9.856 1.258-7.34 14.26z",
    fill: "#FB9300"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.857 366.96h13.107l62.982-101.911h-41.34L102.857 366.96z",
    fill: "#CC395D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.517 173.276l11.01 4.089v6.291l-19.293.839-5.785-9.613 14.068-1.606zM146.16 29.997l-4.246.629s-.472 10.852-2.36 10.695c-1.887-.158-7.549.001-7.549.001l-6.448 6.761H97.719l18.244-16.356 14.312-19.188h15.885v17.458z",
    fill: "#F9B6A8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.803 7.82c4.719-.629 13.212 0 13.841-2.516.629-2.517.629-5.977 3.932-5.19 2.142.51 5.702 13.254-3.303 14.784-8.336 1.415-11.336-1.573-11.336-1.573a5.527 5.527 0 011.696 5.013l-1.677 9.614-2.209-.315s-1.887-5.033-4.089-3.46c-2.202 1.573 2.202 5.348 2.202 5.348l-2.517 4.403-10.38-2.201s9.122-23.278 13.84-23.907z",
    fill: "#523B5D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.657 20.874a1.573 1.573 0 100 3.146 1.573 1.573 0 000-3.146z",
    fill: "#3F2C48"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.673 28.88a10.85 10.85 0 00-2.429-3.223.315.315 0 01.422-.466 11.46 11.46 0 012.571 3.412.314.314 0 11-.564.277z",
    fill: "#CC395D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.375 19.084a2.858 2.858 0 00-2.197-1.076h-.007c-.837 0-1.678.408-2.196 1.064a.472.472 0 01-.741-.584 3.768 3.768 0 012.937-1.424h.009a3.77 3.77 0 012.939 1.44.47.47 0 01-.372.761.47.47 0 01-.372-.181z",
    fill: "#3A3B39"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.25 45.252c-27.261-.35-41.125 31.338-44.989 41.911-.844 2.31-1.733 4.6-2.697 6.862-4.753 11.144-18.864 48.127-20.257 97.203-1.678 59.113 17.615 80.083 40.263 83.438 22.648 3.356 66.266 0 66.266 0 14.648-14.457 25.242-30.517 32.713-47.812l-4.443-92.269 22.058-74.654c-12.582-15.937-56.2-14.26-88.913-14.68z",
    fill: "#00A650"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.036 123.262s-16.681 50.852-7.244 76.436c2.967 8.045 15.207 10.717 27.803 9.437l-3.489-74.549-17.07-11.324z",
    fill: "#3A3B39"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.776 184.495c14.679-72.138 20.97-108.626 8.388-124.563-20.368 9.829-36.862 25.625-39.13 63.33 0 0-13.296 47.393-3.859 72.977 9.436 25.583 92.059-11.744 92.059-11.744l-3.355-10.066-54.103 10.066z",
    fill: "#00A650"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.542 274.666l-58.436 99.84h15.083s108.357-112.92 75.339-137.768c-12.539-9.436-85.978-9.884-85.978-9.884l-32.714 47.812h86.706z",
    fill: "#E73A5E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.111 35.815s11.534 2.202 9.804-5.19c0 0-5.82-.052-9.804 5.19z",
    fill: "#523B5D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.309 192.673l8.105-9.414-6.638 1.235-1.467 8.179z",
    fill: "#3A3B39"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.235 274.666l-16.505 6.513 3.812-6.513h12.693z",
    fill: "#CC395D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.77 287.504c-32.93-16.359-45.146-63.772-37.578-98.319.373-1.699 2.089-2.783 3.837-2.421 1.746.363 2.86 2.034 2.488 3.733-3.613 16.495-2.415 35.619 3.288 52.468 6.189 18.281 17.164 32.108 30.905 38.935 1.59.79 2.222 2.685 1.41 4.233-.572 1.089-1.706 1.716-2.883 1.716-.495 0-.997-.111-1.468-.345z",
    fill: "#3A3B39"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.386 157.631a79.68 79.68 0 01-16.066-3.894c-2.675-.952-5.548-2.061-8.265-1.241-3.758 1.132-5.537 5.367-6.685 9.145-2.11 6.948-3.75 14.171-3.293 21.422 1.872 29.67 49.713 30.408 61.185 7.295 4.638-9.276 2.316-22.066-6.318-27.74-5.96-3.917-13.504-4.038-20.558-4.987z",
    fill: "#523B5D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.029 185.193a4.995 4.995 0 01-4.988 4.99h-.056V176.34h.056a4.994 4.994 0 014.988 4.989v3.864zm-5.044-12.962v-2.963h-23.001v25.675a2.31 2.31 0 002.31 2.309h18.381a2.31 2.31 0 002.31-2.309v-.653h.056c5.016 0 9.098-4.081 9.098-9.098v-3.864c0-5.016-4.082-9.097-9.098-9.097h-.056z",
    fill: "#F1BF15"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M213.803 129.986l1.633-4.597 53.542 4.291-1.604 4.904-53.571-4.598zM209.973 142.248l1.61-4.598 52.798 4.291-1.581 4.905-52.827-4.598z",
    fill: "#E2F3EB"
  })));
}
export default SvgChangeEmail;